import { ErrorHandler, Injectable } from '@angular/core';

declare let newrelic: { noticeError(error: any): void };

@Injectable()
export class NewRelicErrorHandler implements ErrorHandler {
  handleError(error) {
    try {
        newrelic.noticeError(error);
    } catch {
    } finally {
        console.error(error);
    }
  }
}
